// extracted by mini-css-extract-plugin
export default {"dropTargetBefore":"JottingDragDrop_dropTargetBefore__q4UN7","dropTargetAfter":"JottingDragDrop_dropTargetAfter__-d7NR"};